<template>
  <v-container fluid>
    <v-card elevation="2" outlined shaped tile>
      <v-row style="height: 60px;align-items: flex-end;">
        <v-col cols="2">
          <div class="text" style="padding-left: 10px">
            <strong>Satellite pass predictions:</strong>
          </div>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            id="OCO2"
            color="blue"
            value="OCO-2"
            v-model="checkedSat"
            @change="checkSat($event)"
            label="OCO-2"
            dense
            hide-details
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            id="OCO3"
            color="green"
            value="OCO-3"
            v-model="checkedSat"
            @change="checkSat($event)"
            label="OCO-3"
            
            dense
            hide-details
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            id="S5P"
            color="grey"
            value="S5P"
            v-model="checkedSat"
            @change="checkSat($event)"
            label="S5P"
            dense
            hide-details
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            id="IASIB"
            v-model="checkedSat"
            value="IASI-B"
            label="METOP-B"
            color="orange"
            dense
            hide-details
            class="ma-0 pa-0"
            @change="checkSat($event)"
          />
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            id="IASIC"
            color="red"
            value="IASI-C"
            v-model="checkedSat"
            @change="checkSat($event)"
            label="METOP-C"
            dense
            hide-details
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            id="METOP-SG"
            color="#F4A261"
            value="METOP-SG"
            v-model="checkedSat"
            @change="checkSat($event)"
            label="METOP-SG"
            dense
            hide-details
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto">
          <v-checkbox
            id="MICROCARB"
            color="#3FA7D6"
            value="MICROCARB"
            v-model="checkedSat"
            @change="checkSat($event)"
            label="MICROCARB"
            dense
            hide-details
            class="ma-0 pa-0"
          ></v-checkbox>
        </v-col>
        <v-col cols="auto" style="padding-right: 100px; padding-top: 15px">
          <v-select
            :items="satdelay"
            item-value="id"
            item-text="label"
            v-model="duration"
            @change="reloadSat($event)"
            filled
            
            dense
            hide-details
            class="ma-0 pa-0"
            style="width: 180px"
          ></v-select>
        </v-col>
      </v-row>
      <v-row >
        <v-col cols="auto">
          <div class="text" style="padding-left: 10px">
            <strong>Ballon trajectory forecasts:</strong>
          </div>
        </v-col>
        <v-col cols="auto">
          <v-radio-group
            v-model="checkedBal"
            @change="checkBal($event)"
            row
            dense
            style="margin: 0px"
          >
            <v-radio id="Dnone" value="" label="None" dense></v-radio>
            <v-radio id="D0" value="D0" label="Today" dense></v-radio>
            <v-radio id="D1" value="D1" label="Today+1" dense></v-radio>
            <v-radio id="D2" value="D2" label="Today+2" dense></v-radio>
            <v-radio id="D3" value="D3" label="Today+3" dense></v-radio>
            <v-radio id="D4" value="D4" label="Today+4" dense></v-radio>
            <v-radio id="D5" value="D5" label="Today+5" dense></v-radio>
            <v-radio id="D6" value="D6" label="Today+6" dense></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <div
        id="mapid"
        style="margin: 0px 0px 0px 0px; width: 100%; height: 600px; z-index: 0"
      ></div>
    </v-card>

    <v-card elevation="2" outlined shaped tile>
      <v-toolbar flat>
        <v-toolbar-title><strong>Satellite passes:</strong></v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" dark background-color="teal darken-3">
            <v-tabs-slider color="yellow"></v-tabs-slider>

            <v-tab key="item1"> Near stations </v-tab>
            <v-tab key="item2"> Near balloon landing sites </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items v-model="tab">
        <v-tab-item key="item1">
          <v-card flat>
            <v-card-text
              >Satellites passes near stations (&lt; 150km) for the next 14
              days:</v-card-text
            >

            <v-simple-table dense class="sat-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="site-col">Site</th>
                    <th
                      v-for="d in options"
                      :key="d.value"
                      style="text-align: center"
                    >
                      {{ d.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="site">KIR<br /><span>Kiruna</span></td>
                    <td v-for="e in listK" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">ASA<br /><span>Aire sur l'Adour</span></td>
                    <td v-for="e in listAA" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">MDH<br /><span>Reims</span></td>
                    <td v-for="e in listMDH" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">OPGC<br /><span>Puy de Dome</span></td>
                    <td v-for="e in listPD" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">TRN<br /><span>Trainou</span></td>
                    <td v-for="e in listT" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">Montreal</td>
                    <td
                      v-for="e in listMontreal"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                  <tr>
                    <td class="site">Timmins</td>
                    <td
                      v-for="e in listTimmins"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                  <tr>
                    <td class="site">Palmas</td>
                    <td
                      v-for="e in listPalmas"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                  <tr>
                    <td class="site">SantaMaria</td>
                    <td
                      v-for="e in listSantaMaria"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <br />
            <!--
        <h3>Select a date to get next satelittes passes close to the stations:
        <select id="distance" @change="reloadDist($event)" v-model="distance">
          <option value="">Select a day</option>
          <option v-for="option in options" v-bind:value="option.ID">
      {{ option.text }}
    </option>
            </select></h3>
            <h4 v-if="listK != ''">KIR - Kiruna</h4>
            <span v-html="listK"></span>
            <h4 v-if="listAA != ''">ASA - Aire sur Adoure</h4>
        <span v-html="listAA"></span>
            <h4 v-if="listMDH != ''">MDH - Reims</h4>
        <span v-html="listMDH"></span>
            <h4 v-if="listPD != ''">OPGC - Puy de Dome</h4>
        <span v-html="listPD"></span>
            <h4 v-if="listT != ''">TRN - Trainou</h4>
        <span v-html="listT"></span>
        <br />-->
            <h3 style="padding: 0px 0px 0px 10px; margin: 0px">
              CSV files detailing satellite passes near stations:
            </h3>
            <table style="padding: 0px 0px 0px 10px; margin: 0px">
              <tr>
                <td style="vertical-align: top; padding: 0px; margin: 0px">
                  <ul>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Kiruna_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_Kiruna_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_AireAdour_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_AireAdour_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_MDHReims_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_MDHReims_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_PuyDome_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_PuyDome_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Trainou_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_Trainou_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Montreal_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_Montreal_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Timmins_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_Timmins_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_SantaMaria_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_SantaMaria_LauchingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Palmas_LauchingSite.csv"
                        target="_blank"
                        >MAGIC_Palmas_LauchingSite.csv</a
                      >
                    </li>
                  </ul>
                </td>
                <td style="padding-left: 80px">
                  The files are in CSV format (readable on Excel with the
                  possibility to sort the columns). Below is the description of
                  the different columns:<br />
                  Column 1 ==> Satellite name<br />
                  Column 2 ==> Date of the satellite passage, Format YYMMDDhhmm,
                  hhmm = UTC time<br />
                  Column 3 ==> Azimuth (north) for the nearest point.
                  Trigonometric direction, North (0), West (90), South (180),
                  East (-90)<br />
                  Column 4 ==> Minimum distance between ground station and
                  satellite track<br />
                </td>
              </tr>
            </table>
            <v-card-subtitle>
              <strong
                >Note: only daytime orbits are displayed for OCO-2, OCO-3 and
                S5P<br />
                Due to the specificity of OCO3's orbit, it is possible that no
                daytime passage will take place over Europe for more than 7
                days.</strong
              ></v-card-subtitle
            >
          </v-card>
        </v-tab-item>
        <v-tab-item key="item2">
          <v-card flat>
            <v-card-text
              >Satellites passes near balloon landing sites (&lt; 150km) for the
              next 14 days</v-card-text
            >
            <v-simple-table dense class="sat-table">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="site-col">Site</th>
                    <th
                      v-for="d in options"
                      :key="d.value"
                      style="text-align: center"
                    >
                      {{ d.text }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="site">KIR<br /><span>Kiruna</span></td>
                    <td v-for="e in listK2" v-html="e.text" class="cell"></td>
                  </tr>

                  <tr>
                    <td class="site">ASA<br /><span>Aire-sur-l’Adour</span></td>
                    <td v-for="e in listAA2" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">MDH<br /><span>Reims</span></td>
                    <td v-for="e in listMDH2" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">OPGC<br /><span>Puy de Dome</span></td>
                    <td v-for="e in listPD2" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">TRN<br /><span>Trainou</span></td>
                    <td v-for="e in listT2" v-html="e.text" class="cell"></td>
                  </tr>
                  <tr>
                    <td class="site">Montreal</td>
                    <td
                      v-for="e in listMontreal2"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                  <tr>
                    <td class="site">Timmins</td>
                    <td
                      v-for="e in listTimmins2"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                  <tr>
                    <td class="site">Palmas</td>
                    <td
                      v-for="e in listPalmas2"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                  <tr>
                    <td class="site">SantaMaria</td>
                    <td
                      v-for="e in listSantaMaria2"
                      v-html="e.text"
                      class="cell"
                    ></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <br />
            <!--
              <h3>Select a date to get next satelittes passes close to the stations:
              <select id="distance" @change="reloadDist($event)" v-model="distance">
                <option value="">Select a day</option>
                <option v-for="option in options" v-bind:value="option.ID">
            {{ option.text }}
          </option>
                  </select></h3>
                  <h4 v-if="listK != ''">KIR - Kiruna</h4>
                  <span v-html="listK"></span>
                  <h4 v-if="listAA != ''">ASA - Aire sur Adoure</h4>
              <span v-html="listAA"></span>
                  <h4 v-if="listMDH != ''">MDH - Reims</h4>
              <span v-html="listMDH"></span>
                  <h4 v-if="listPD != ''">OPGC - Puy de Dome</h4>
              <span v-html="listPD"></span>
                  <h4 v-if="listT != ''">TRN - Trainou</h4>
              <span v-html="listT"></span>
              <br />-->
            <h3 style="padding: 0px 0px 0px 10px; margin: 0px">
              CSV files detailing satellite passes near balloon landing sites:
            </h3>
            <table style="padding: 0px 0px 0px 10px; margin: 0px">
              <tr>
                <td style="vertical-align: top; padding: 0px; margin: 0px">
                  <ul>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Kiruna_LandingSite.csv"
                        target="_blank"
                        >MAGIC_Kiruna_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_AireAdour_LandingSite.csv"
                        target="_blank"
                        >MAGIC_AireAdour_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_MDHReims_LandingSite.csv"
                        target="_blank"
                        >MAGIC_MDHReims_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_PuyDome_LandingSite.csv"
                        target="_blank"
                        >MAGIC_PuyDome_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Trainou_LandingSite.csv"
                        target="_blank"
                        >MAGIC_Trainou_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Montreal_LandingSite.csv"
                        target="_blank"
                        >MAGIC_Montreal_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Timmins_LandingSite.csv"
                        target="_blank"
                        >MAGIC_Timmins_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_SantaMaria_LandingSite.csv"
                        target="_blank"
                        >MAGIC_SantaMaria_LandingSite.csv</a
                      >
                    </li>
                    <li>
                      <a
                        href="https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_Palmas_LandingSite.csv"
                        target="_blank"
                        >MAGIC_Palmas_LandingSite.csv</a
                      >
                    </li>
                  </ul>
                </td>
                <td style="padding-left: 80px">
                  The files are in CSV format (readable on Excel with the
                  possibility to sort the columns). Below is the description of
                  the different columns:<br />
                  Column 1 ==> Satellite name<br />
                  Column 2 ==> Date of the satellite passage, Format YYMMDDhhmm,
                  hhmm = UTC time<br />
                  Column 3 ==> Azimuth (north) for the nearest point.
                  Trigonometric direction, North (0), West (90), South (180),
                  East (-90)<br />
                  Column 4 ==> Minimum distance between ground station and
                  satellite track<br />
                </td>
              </tr>
            </table>
            <v-card-subtitle>
              <strong
                >Note: only daytime orbits are displayed for OCO-2, OCO-3 and
                S5P<br />
                Due to the specificity of OCO3's orbit, it is possible that no
                daytime passage will take place over Europe for more than 7
                days.</strong
              ></v-card-subtitle
            >
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
import axios from "axios";

export default {
  name: "Main",
  data() {
    return {
      map: null,
      search: null,
      provider: null,
      checkedSat: [],
      checkedSatP: [],
      checkedBal: [],
      site1: [],
      site2: [],
      site3: [],
      site4: [],
      site5: [],
      tab: null,
      duration: "tracks",
      distance: "",
      layerOCO2: L.layerGroup(),
      layerOCO3: L.layerGroup(),
      layerS5P: L.layerGroup(),
      layerIASIA: L.layerGroup(),
      layerIASIB: L.layerGroup(),
      layerIASIC: L.layerGroup(),
      layerMETOPSG: L.layerGroup(),
      layerMICROCARB: L.layerGroup(),
      layerASA: L.layerGroup(),
      layerGroupBal: [],
      listK: [],
      listPD: [],
      listMDH: [],
      listT: [],
      listAA: [],
      listK2: [],
      listPD2: [],
      listMDH2: [],
      listT2: [],
      listAA2: [],
      listTimmins: [],
      listMontreal: [],
      listSantaMaria: [],
      listPalmas: [],
      listTimmins: [],
      listMontreal2: [],
      listSantaMaria2: [],
      listPalmas2: [],
      options: [],
      satdelay: [
        { id: "tracks", label: "14 day tracks" },
        { id: "tracks_1", label: "Today tracks" },
        { id: "tracks_2", label: "Today +1 tracks" },
        { id: "tracks_3", label: "Today +2 tracks" },
        { id: "tracks_4", label: "Today +3 tracks" },
        { id: "tracks_5", label: "Today +4 tracks" },
        { id: "tracks_6", label: "Today +5 tracks" },
        { id: "tracks_7", label: "Today +6 tracks" },
        { id: "tracks_8", label: "Today +7 tracks" },
        { id: "tracks_9", label: "Today +8 tracks" },
        { id: "tracks_10", label: "Today +9 tracks" },
        { id: "tracks_11", label: "Today +10 tracks" },
        { id: "tracks_12", label: "Today +11 tracks" },
        { id: "tracks_13", label: "Today +12 tracks" },
        { id: "tracks_14", label: "Today +13 tracks" },
      ],
    };
  },
  methods: {
    checkBal: function (event) {
      for (let i = 0; i < this.layerGroupBal.length; i++) {
        let t = this.layerGroupBal[i];
        t.clearLayers();
      }

      if (this.checkedBal != "") {
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_AireAdour_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_Kiruna_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_MDHReims_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_PuyDome_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_Trainou_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_Palmas_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_SantaMaria_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_Montreal_" +
            this.checkedBal +
            "_T10:00.json"
        );
        this.displayBalTraj(
          "https://data.ipsl.fr/magic/qlooks/TRAJ/PREVIBALLONS/AIRCORE/previ_ballon_Timmins_" +
            this.checkedBal +
            "_T10:00.json"
        );
      }
    },
    displayBalTraj: function (url) {
      var blastIcon = new L.Icon({
        iconUrl: "https://observations.ipsl.fr/aeris/magic/windy/img/blast.png",
        iconSize: [25, 25],
        iconAnchor: [12, 15],
      });

      var endIcon = new L.Icon({
        iconUrl: "https://observations.ipsl.fr/aeris/magic/windy/img/end.png",
        iconSize: [25, 25],
        iconAnchor: [3, 24],
      });

      axios.get(url).then((response) => {
        let n = 2;
        let fo = 1 - (n * 3.5) / 100;
        var tab = response.data;
        var group = L.featureGroup();
        var pointList1 = [];
        let couleur = "#000000";
        let altmin = 0;
        let blast = null;
        let blastpopup = "";
        let end = null;
        let endpopup = "";
        for (var i = 1; i < tab.length; i++) {
          let popup =
            "<strong>Trajectory forecast</strong><br />Datetime: " +
            tab[i][0] +
            " UTC<br />Latitude: " +
            tab[i][1] +
            "°<br />Longitude: " +
            tab[i][2] +
            "°<br />Elevation: " +
            tab[i][3] +
            " (m)";
          L.circle([tab[i][1], tab[i][2]], {
            color: couleur,
            fillColor: couleur,
            fillOpacity: fo,
            opacity: fo,
            weight: n,
          })
            .bindPopup(popup)
            .addTo(group);

          var pointA = new L.LatLng(tab[i][1], tab[i][2]);

          if (altmin < tab[i][3]) {
            blast = pointA;
            blastpopup = popup;
          }
          end = pointA;
          endpopup = popup;

          altmin = tab[i][3];
          pointList1.push(pointA);
        }

        var firstpolyline = new L.Polyline(pointList1, {
          color: couleur,
          weight: 1,
          opacity: fo,
          smoothFactor: 1,
        });

        firstpolyline.addTo(group);
        L.marker(blast, { icon: blastIcon })
          .addTo(group)
          .bindPopup("<b>BLAST</b><br />" + blastpopup);
        L.marker(end, { icon: endIcon })
          .addTo(group)
          .bindPopup("<b>END</b><br />" + endpopup);
        this.map.addLayer(group);

        this.layerGroupBal.push(group);
        pointList1 = [];
      });
    },
    reloadSat: function (event) {
      let dur = "";
      if (this.duration.length > 6) dur = this.duration.slice(6);
      let url = "";
      for (var i = 0; i < this.checkedSat.length; i++) {
        switch (this.checkedSat[i]) {
          case "OCO-2":
            this.layerOCO2.clearLayers();
            url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/OCO2" + dur + ".json";
            this.displayResults(url, "OCO-2", "blue");

            break;
          case "OCO-3":
            this.layerOCO3.clearLayers();
            url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/OCO3" + dur + ".json";
            this.displayResults(url, "OCO-3", "green");

            break;
          case "S5P":
            this.layerS5P.clearLayers();
            url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/SENTINEL-5P" +
              dur +
              ".json";
            this.displayResults(url, "S5P", "grey");

            break;
          case "IASI-A":
            this.layerIASIA.clearLayers();
            url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-A" + dur + ".json";
            this.displayResults(url, "IASI-A", "brown");

            break;
          case "IASI-B":
            this.layerIASIB.clearLayers();
           url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-B" + dur + ".json";
            this.displayResults(url, "IASI-B", "orange");

            break;
          case "IASI-C":
            this.layerIASIC.clearLayers();
            url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-C" + dur + ".json";
            this.displayResults(url, "IASI-C", "red");
            break;
          case "METOP-SG":
            this.layerMETOPSG.clearLayers();
            url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-SG" + dur + ".json";
            this.displayResults(url, "METOP-SG", "#F4A261");
            break;
          case "MICROCARB":
            this.layerMICROCARB.clearLayers();
            url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/MICROCARB" + dur + ".json";
            this.displayResults(url, "MICROCARB", "#3FA7D6");
            break;
        }
      }
    },
    checkSat: function (event, v) {
      let inter = [];
      let b = this.checkedSat.length < this.checkedSatP.length;

      if (b)
        inter = this.checkedSatP.filter(
          (x) => this.checkedSat.indexOf(x) === -1
        );
      else
        inter = this.checkedSat.filter(
          (x) => this.checkedSatP.indexOf(x) === -1
        );

      this.checkedSatP = this.checkedSat;

      let dur = "";
      if (this.duration.length > 6) dur = this.duration.slice(6);

      switch (inter[0]) {
        case "OCO-2":
          if (!b) {
            //let url = "https://climserv.ipsl.polytechnique.fr/apiixion/?resource=orbitography&sat=oco%202&duration=7&format=json&step=-30&hour=00&min=00&sec=00";
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/OCO2" + dur + ".json";
            this.displayResults(url, "OCO-2", "blue");
          } else {
            this.layerOCO2.clearLayers();
          }
          break;
        case "OCO-3":
          if (!b) {
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/OCO3" + dur + ".json";
            this.displayResults(url, "OCO-3", "green");
          } else {
            this.layerOCO3.clearLayers();
          }
          break;
        case "S5P":
          if (!b) {
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/SENTINEL-5P" +
              dur +
              ".json";
            this.displayResults(url, "S5P", "grey");
          } else {
            this.layerS5P.clearLayers();
          }
          break;
        case "IASI-A":
          if (!b) {
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-A" + dur + ".json";
            this.displayResults(url, "IASI-A", "red");
          } else {
            this.layerIASIA.clearLayers();
          }
          break;
        case "IASI-B":
          if (!b) {
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-B" + dur + ".json";
            this.displayResults(url, "IASI-B", "orange");
          } else {
            this.layerIASIB.clearLayers();
          }
          break;
        case "IASI-C":
          if (!b) {
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-C" + dur + ".json";
            this.displayResults(url, "IASI-C", "brown");
          } else {
            this.layerIASIC.clearLayers();
          }
          break;
        case "METOP-SG":
          if (!b) {
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/METOP-SG" +
              dur +
              ".json";
            this.displayResults(url, "METOP-SG", "#F4A261");
          } else {
            this.layerMETOPSG.clearLayers();
          }
          break;
        case "MICROCARB":
          if (!b) {
            let url =
              "https://data.ipsl.fr/magic/qlooks/DEPOT/MICROCARB" +
              dur +
              ".json";
            this.displayResults(url, "MICROCARB", "#3FA7D6");
          } else {
            this.layerMICROCARB.clearLayers();
          }
          break;
      }
    },
    plotCircle: function (lat, lon, plat, plon, txt, color, layer) {
      var circle = L.circle([lon, lat], {
        //radius: 50000,
        weight: 4,
        opacity: 1,
        fillOpacity: 0.3,
        fillColor: color,
        color: color,
      }).bindPopup(txt);

      var style = {
        color: color,
        weight: 1,
        opacity: 0.8,
        smoothFactor: 1,
      };

      // bug lat et lon inversé !!!!!
      if (
        (lon > 30 && lat < 50 && lon < 80 && lat > -20) ||
        (lat > -120 && lon < 60 && lat < -40 && lon > 30) ||
        (lat > -80 && lon < 0 && lat < -30 && lon > -50)
      ) {
        var pol = L.polyline(
          [
            [plon, plat],
            [lon, lat],
          ],
          style
        );
        layer.addLayer(circle);
        layer.addLayer(pol);
      }
    },
    displayTrajSat: function (data, sat, color, layer) {
      for (let i = 0; i < data.length; i++) {
        let jn = "Nuit";
        if (data[i][12] == "**") jn = "Jour";
        let popup =
          "<h2>" +
          sat +
          "</h2>DateTime (UTC): " +
          data[i][0] +
          "-" +
          data[i][1] +
          "-" +
          data[i][2] +
          " " +
          data[i][3] +
          ":" +
          data[i][4] +
          ":" +
          data[i][5];
        popup += "<br>Longitude: " + data[i][6];
        popup += "<br>Lat.gc_T.: " + data[i][7];
        popup += "<br>Lat.gd_T.: " + data[i][8];
        popup += "<br>Lat.gd_N.: " + data[i][9];
        popup += "<br>Altit. (km): " + data[i][10];
        popup += "<br>S Zen: " + data[i][11];
        popup += "<br>Jour/Nuit : " + jn;
        popup += "<br>S Azi" + data[i][13];
        popup += "<br>TSM: " + data[i][14] + ":" + data[i][15];
        popup += "<br>ECL: " + data[i][16];

        let plat = data[i][6];
        let plon = data[i][7];
        if (i > 0) {
          plat = data[i - 1][6];
          plon = data[i - 1][8];
        }
        if (sat != "OCO-2" && sat != "OCO-3" && sat != "S5P")
          this.plotCircle(
            data[i][6],
            data[i][8],
            plat,
            plon,
            popup,
            color,
            layer
          );
        else if (jn == "Jour")
          this.plotCircle(
            data[i][6],
            data[i][8],
            plat,
            plon,
            popup,
            color,
            layer
          );
      }
    },
    loadSite: function (site) {
      axios
        .get(
          "https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_" +
            site +
            "_LauchingSite.csv"
        )
        .then((response) => {
          let str = response.data;
          let arr = str.split("\n");
          let slist = [];
          for (let j = 0; j < this.options.length; j++) {
            let sday = this.options[j].ID;
            let tmp = "";
            for (let i = 0; i < arr.length; i++) {
              let line = arr[i].split(";");

              if (line.length == 4) {
                let sat = line[0].replace(/\s+/g, "");
                let d = line[1].replace(/\s+/g, "");
                let sd = d.substring(6, 8) + ":" + d.substring(8, 10);
                let azi = line[2].replace(/\s+/g, "");
                let dist = line[3].replace(/\s+/g, "");

                if (d.substring(0, 6) == sday && parseInt(dist) < 150) {
                  if (sat == "OCO2" || sat == "OCO3" || sat == "SENTINEL-5P") {
                    let h = parseInt(d.substring(6, 8));
                    if (h > 7 && h < 18)
                      tmp +=
                        "<strong>" +
                        sat +
                        "</strong><br />" +
                        sd +
                        "&nbsp;-&nbsp;" +
                        dist +
                        "km<br />";
                  } else
                    tmp +=
                      "<strong>" +
                      sat +
                      "</strong><br />" +
                      sd +
                      "&nbsp;-&nbsp;" +
                      dist +
                      "km<br />";
                }
              }
            }
            slist.push({
              text: tmp,
            });
          }

          switch (site) {
            case "Kiruna":
              this.listK = slist;
              break;
            case "PuyDome":
              this.listPD = slist;
              break;
            case "MDHReims":
              this.listMDH = slist;
              break;
            case "Trainou":
              this.listT = slist;
              break;
            case "AireAdour":
              this.listAA = slist;
              break;
            case "Timmins":
              this.listTimmins = slist;
              break;
            case "Montreal":
              this.listMontreal = slist;
              break;
            case "SantaMaria":
              this.listSantaMaria = slist;
              break;
            case "Palmas":
              this.listPalmas = slist;
              break;
          }
        })
        .catch((error) => console.log(error));
    },

    loadSite2: function (site) {
      axios
        .get(
          "https://data.ipsl.fr/magic/qlooks/DEPOT/MAGIC_" +
            site +
            "_LandingSite.csv"
        )
        .then((response) => {
          let str = response.data;
          let arr = str.split("\n");
          let slist = [];
          for (let j = 0; j < this.options.length; j++) {
            let sday = this.options[j].ID;
            let tmp = "";
            for (let i = 0; i < arr.length; i++) {
              let line = arr[i].split(";");

              if (line.length == 4) {
                let sat = line[0].replace(/\s+/g, "");
                let d = line[1].replace(/\s+/g, "");
                let sd = d.substring(6, 8) + ":" + d.substring(8, 10);
                let azi = line[2].replace(/\s+/g, "");
                let dist = line[3].replace(/\s+/g, "");

                if (d.substring(0, 6) == sday && parseInt(dist) < 150) {
                  if (sat == "OCO2" || sat == "OCO3" || sat == "SENTINEL-5P") {
                    let h = parseInt(d.substring(6, 8));
                    if (h > 7 && h < 18)
                      tmp +=
                        "<strong>" +
                        sat +
                        "</strong><br />" +
                        sd +
                        "&nbsp;-&nbsp;" +
                        dist +
                        "km<br />";
                  } else
                    tmp +=
                      "<strong>" +
                      sat +
                      "</strong><br />" +
                      sd +
                      "&nbsp;-&nbsp;" +
                      dist +
                      "km<br />";
                  // tmp += sat + ' - ' + sd + ' - ' + dist + 'km - Azimuth: ' + azi + '<br />';
                }
              }
            }
            slist.push({
              text: tmp,
            });
          }
          /*
          this.options.push({
        ID: syear + smonth + sday, 
        text: year + '-' + smonth + '-' + sday, 
      });
      */

          switch (site) {
            case "Kiruna":
              this.listK2 = slist;
              break;
            case "PuyDome":
              this.listPD2 = slist;
              break;
            case "MDHReims":
              this.listMDH2 = slist;
              break;
            case "Trainou":
              this.listT2 = slist;
              break;
            case "AireAdour":
              this.listAA2 = slist;
              break;
            case "Timmins":
              this.listTimmins2 = slist;
              break;
            case "Montreal":
              this.listMontreal2 = slist;
              break;
            case "SantaMaria":
              this.listSantaMaria2 = slist;
              break;
            case "Palmas":
              this.listPalmas2 = slist;
              break;
          }
        })
        .catch((error) => console.log(error));
    },
    displayResults: function (url, sat, color) {
      axios
        .get(url)
        .then((response) => {
          switch (sat) {
            case "OCO-2":
              this.displayTrajSat(response.data, sat, color, this.layerOCO2);
              this.map.addLayer(this.layerOCO2);
              break;
            case "OCO-3":
              this.displayTrajSat(response.data, sat, color, this.layerOCO3);
              this.map.addLayer(this.layerOCO3);
              break;
            case "S5P":
              this.displayTrajSat(response.data, sat, color, this.layerS5P);
              this.map.addLayer(this.layerS5P);
              break;
            case "IASI-A":
              this.displayTrajSat(response.data, sat, color, this.layerIASIA);
              this.map.addLayer(this.layerIASIA);
              break;
            case "IASI-B":
              this.displayTrajSat(response.data, sat, color, this.layerIASIB);
              this.map.addLayer(this.layerIASIB);
              break;
            case "IASI-C":
              this.displayTrajSat(response.data, sat, color, this.layerIASIC);
              this.map.addLayer(this.layerIASIC);
              break;
            case "METOP-SG":
              this.displayTrajSat(response.data, sat, color, this.layerMETOPSG);
              this.map.addLayer(this.layerMETOPSG);
              break;
            case "MICROCARB":
              this.displayTrajSat(response.data, sat, color, this.layerMICROCARB);
              this.map.addLayer(this.layerMICROCARB);
              break;
          }
        })
        .finally((response) => {
          //document.body.style.cursor='default';
        })
        .catch((error) => console.log(error));
    },
    displayLocSquare: function (lat, lon, color, txt) {
      var myIcon = new L.Icon({
        iconUrl:
          "https://observations.ipsl.fr/aeris/magic/windy/img/marker-icon-green.png",
        shadowUrl:
          "https://observations.ipsl.fr/aeris/magic/windy/img/marker-shadow.png",
        iconAnchor: [12, 41],
      });

      var marker = L.marker([lat, lon], { icon: myIcon }).addTo(this.map);
      marker.bindPopup(txt);
      /*
     var circle = L.circle([lat, lon], 200000, {
      weight: 0,
      opacity: 0,
      fillOpacity: 0
    }).addTo(this.map);

    var rectangle = new L.Rectangle(circle.getBounds(),{
        weight: 2,
        color: color,
        opacity: 1,
        fillColor: color,
        fillOpacity: 0
      }).addTo(this.map);*/
    },
  },
  mounted() {
    this.map = L.map("mapid", {
      //
      center: [49.243, 4.068],
      zoom: 3,
    });
    this.map.scrollWheelZoom.disable();
    /*
    this.provider = new GeoSearch.OpenStreetMapProvider();
    this.search = new GeoSearch.GeoSearchControl({
      provider: this.provider, showMarker: false,
      showPopup: false,
      retainZoomLevel: true
    });
    this.map.addControl(this.search);*/

    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZG91ZGFpZXYiLCJhIjoiY2syMzhlYnpzMDFpbjNucDltaTIzb2FneSJ9.DtU_NDpOdx1SJ04P8ueJcw",
      {
        maxZoom: 18,
        noWrap: true,
        attribution: "",
        id: "mapbox/streets-v11",
      }
    ).addTo(this.map);
    this.displayLocSquare(45.772, 2.966, "grey", "<h3>OPGC - Puy de Dome</h3>");
    this.displayLocSquare(47.974, 2.092, "red", "<h3>TRN - Trainou</h3>");
    this.displayLocSquare(
      43.708,
      -0.251,
      "green",
      "<h3>ASA - Aire sur l'Adour</h3>"
    );
    this.displayLocSquare(49.243, 4.068, "blue", "<h3>MDH - Reims</h3>");
    this.displayLocSquare(
      -10.17325,
      -48.47316666666667,
      "blue",
      "<h3>Palmas</h3>"
    );
    this.displayLocSquare(
      -29.7574722,
      -53.8034166666,
      "blue",
      "<h3>Santa Maria</h3>"
    );
    this.displayLocSquare(45.5513611, -73.1556111, "blue", "<h3>Montreal</h3>");
    this.displayLocSquare(48.5676111, -81.3668333, "blue", "<h3>Timmins</h3>");
    this.displayLocSquare(67.888, 21.083, "red", "<h3>KIR - Kiruna</h3>");
    // this.displayLocSquare(48.846, 2.356, "orange",  "<h3>TCCON - Paris</h3>");
    // this.displayLocSquare(67.8833333, 21.06666, "brown",  "<h3>Esrange-Kiruna</h3>");
    this.displayLocSquare(67.36, 26.63, "yellow", "<h3>Sodankyla</h3>");
    // this.displayLocSquare(66.0137083, 8.074022, "blue",  "<h3>Norne</h3>");

    //this.map.scrollWheelZoom.disable();
    L.control.scale().addTo(this.map);

    // AJOUT DES STATION TCCON
    axios
      .get("https://data.ipsl.fr/magic/qlooks/FEATURES/TCCON_stations.csv")
      .then((response) => {
        var res = response.data;
        var allLines = res.split(/\r\n|\n/);
        var stations = [];
        allLines.forEach((line) => {
          let l = line.split(";");

          if (l.length >= 3) {
            var orangeIcon = new L.Icon({
              iconUrl:
                "https://observations.ipsl.fr/aeris/magic/windy/img/marker-icon-orange.png",
              shadowUrl:
                "https://observations.ipsl.fr/aeris/magic/windy/img/marker-shadow.png",
              iconAnchor: [12, 41],
            });
            let m = L.marker([l[1], l[2]], { icon: orangeIcon }).bindPopup(
              "<strong>TCCON station</strong><br />" + l[0]
            );
            stations.push(m);
          }
        });

        const stationlayer = L.layerGroup(stations);
        const overlays = {
          "TCCON stations": stationlayer,
        };
        const layerControl = L.control.layers(null, overlays).addTo(this.map);
        this.map.addLayer(stationlayer);
      });

    let d = new Date();

    for (let i = 0; i < 14; i++) {
      let day = d.getUTCDate();
      let month = d.getUTCMonth() + 1;
      let year = d.getUTCFullYear();
      let syear = year.toString().substr(-2);

      let sday = "0" + day;
      sday = sday.slice(-2);
      let smonth = "0" + month;
      smonth = smonth.slice(-2);
      this.options.push({
        ID: syear + smonth + sday,
        text: year + "-" + smonth + "-" + sday,
      });
      d.setDate(d.getUTCDate() + 1);
    }

    this.loadSite("MDHReims");
    this.loadSite("PuyDome");
    this.loadSite("Trainou");
    this.loadSite("AireAdour");
    this.loadSite("Kiruna");
    this.loadSite("Timmins");
    this.loadSite("Montreal");
    this.loadSite("SantaMaria");
    this.loadSite("Palmas");

    this.loadSite2("MDHReims");
    this.loadSite2("PuyDome");
    this.loadSite2("Trainou");
    this.loadSite2("AireAdour");
    this.loadSite2("Kiruna");
    this.loadSite2("Timmins");
    this.loadSite2("Montreal");
    this.loadSite2("SantaMaria");
    this.loadSite2("Palmas");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
table {
  border-collapse: collapse;
  font-family: Tahoma, Geneva, sans-serif;
}
table td {
  padding: 0px;
}
table thead td {
  background-color: #a0a0a1;
  color: #ffffff;
  font-weight: bold;
  font-size: 11px;
  border: 1px solid #a0a0a1;
}
table tbody td {
  color: #636363;
  border: 1px solid #dddfe1;
  font-size: 11px;
}
table tbody tr {
  background-color: #f9fafb;
}
table tbody tr:nth-child(odd) {
  background-color: #ffffff;
}

.sat-table {
  font-size: 11px;
}

.sat-table thead th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  padding: 6px 8px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.site-col {
  width: 130px;
}

.site {
  font-weight: 600;
  line-height: 1.1;
}

.site span {
  font-weight: 400;
  font-size: 12px;
  color: #666;
}

.cell {
  text-align: center;
  line-height: 1.2 !important;
  font-size: 12px !important;
}

tbody tr:hover {
  background: #fafafa;
}

.date-col {
  text-align: center;
  min-width: 10px;
  white-space: nowrap;
}
</style>
